// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2d940025","455":"f11c6ad4","977":"c486f5e7"}[chunkId] + ".chunk.js";
};